import { render, staticRenderFns } from "./SysLog.vue?vue&type=template&id=2dfe2c43&scoped=true"
import script from "./SysLog.vue?vue&type=script&lang=js"
export * from "./SysLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe2c43",
  null
  
)

export default component.exports